import { State } from "../types";

export type ShowTableUIAction = Readonly<{
  type: "SHOW TABLE UI";
}>;

export const showTableUI = (state: State, _action: ShowTableUIAction): State => {
  if (state.showTableUI) {
    return state;
  }
  return {
    ...state,
    showTableUI: true,
  };
};
